import { render, staticRenderFns } from "./ParentSelectionInputBlock.vue?vue&type=template&id=8d741662&scoped=true"
import script from "./ParentSelectionInputBlock.vue?vue&type=script&lang=ts"
export * from "./ParentSelectionInputBlock.vue?vue&type=script&lang=ts"
import style0 from "./ParentSelectionInputBlock.vue?vue&type=style&index=0&id=8d741662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d741662",
  null
  
)

export default component.exports